import { useEffect } from "react";
import { logPageView } from "../helper/AppInsightsHelper";
import { Paper } from "@mui/material";
import { PaperHeaderText } from "../helper/PaperHeaderText";
import HomeComponent from "../components/Home/HomeComponent";

export default function ProductScorecard() {
    const subTitle = "Quick view of top metrics for security products. To explore product metrics in detail, click on the product hyperlink.";

    useEffect(() => {
        logPageView("Product Scorecard Page", window.location.href);
    }, []);

    return (
    <>
        <Paper sx={{ paddingBottom: "5px", paddingTop: "10px" }}>
            <PaperHeaderText text="Top metrics at a glance" />
            <p
            style={{
                color: "black",
                fontWeight: 500,
                margin: 10,
                padding: "5px"
            }}
            >
            {subTitle}
            </p>
            <HomeComponent />
        </Paper>
    </>
    );
}